/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

import { cn, tailwindUtils } from '@/shared/ui/utils/tailwind';
import { UnstyledButton } from '@/shared/ui';

export type PropertyDrawerSubmitButtonProps = {
  label: string;
  savingLabel: string;
  disabled: boolean;
  onClick: () => void;
};

/**
 * Footer submit button for the property drawer (auto width, not full-bleed).
 */
export function SubmitButton({
  label,
  savingLabel,
  disabled,
  onClick,
}: PropertyDrawerSubmitButtonProps) {
  return (
    <UnstyledButton
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label={label}
      data-testid="property-drawer-submit"
      className={cn(
        tailwindUtils.buttonBase,
        'h-10 min-w-[7.5rem] px-(--space-5)',
        'bg-(--button-primary-bg) text-(--button-primary-text)',
        'hover:bg-(--button-primary-hover-bg) hover:shadow-[var(--shadow-md)]',
        'text-[length:var(--text-body)]',
        'font-[weight:var(--font-semibold)]',
        'leading-[var(--leading-snug)]',
        'font-[family-name:var(--font-family)]',
        'disabled:cursor-not-allowed disabled:opacity-60',
      )}
    >
      {disabled ? savingLabel : label}
    </UnstyledButton>
  );
}
